<template>
  <el-card
    class="box-card"
    :style="{'marginTop':  $store.state.chat.isMobileMode ? '80px' : 'unset'}"
  >
    <span
      class="close-ui-profile"
      @click="$store.dispatch('contact/setActiveContactCustumer', null)"
    >
      <i class="fas fa-times"></i>
    </span>
    <div class="ui-profile">
      <div class="avatar">
        <img
          v-if="customerContact.custImage"
          :src="
            `https://cdnx.softsq.com/thumb/unsafe/84x84/${encodeURIComponent(
              encodeURIComponent(customerContact.custImage),
            )}`
          "
        />
      </div>
      <p class="text-nameline" v-text="customerContact.custName"></p>
      <strong
        class="center"
        v-text="
          customerContact.custNameNew == ''
            ? customerContact.custName
            : customerContact.custNameNew
        "
        v-show="!isShowEditText"
      ></strong>
      <el-input
        placeholder="Please input"
        ref="custName"
        :value="
          custNameProfile == null
            ? customerContact.custNameNew == '' ? customerContact.custName : customerContact.custNameNew
            : custNameProfile
        "
        @input="enterContact"
        v-show="isShowEditText"
      ></el-input>
      <el-button
        type="primary"
        size="medium"
        icon="el-icon-edit"
        circle
        @click="$store.dispatch('contact/setIsShowEdit', true)"
        v-show="!isShowEditText"
      ></el-button>
      <div class="bottom clearfix" v-show="isShowEditText">
        <el-button
          type="info"
          size="medium"
          round
          @click="$store.dispatch('contact/setIsShowEdit', false)"
        >Cancel</el-button>
        <el-button type="success" size="medium" round @click="fnSaveContact">Save</el-button>
      </div>
      <br />
      <br />
      <div class="center box-add-tag">
        <el-tag
          :key="tag"
          v-for="tag in dynamicTags"
          closable
          :disable-transitions="false"
          @close="handleClose(tag)"
        >{{tag}}</el-tag>
        <el-input
          class="input-new-tag"
          v-if="inputVisible"
          v-model="inputValue"
          ref="saveTagInput"
          size="mini"
          @keyup.enter.native="handleInputConfirm"
          @keydown.tab.native="handleInputConfirm"
        ></el-input>
        <!-- เอาออกชั่วคราว 2025-11-11 ต้องการเพิ่มแท๊กใหม่แจ้งทีมพัฒนา -->
        <!-- <el-button v-else class="button-new-tag" size="medium" @click="showInput">+ Add Tag</el-button> -->
        <transition name="component-fade" mode="out-in">
          <h4 class="uk-text-success" v-if="isShowSuccess">
            <span class="uk-margin-small-right" uk-icon="check"></span>
            บันทึกสำเร็จ
          </h4>
        </transition>
        <transition name="component-fade" mode="out-in">
          <h4 class="uk-text-danger" v-if="isShowError">
            <span class="uk-margin-small-right" uk-icon="close"></span>
            {{ isShowMsg }}
          </h4>
        </transition>
        <div
          class="uk-margin-top uk-card uk-card-default uk-card-body box-tag"
          :class="{ 'scroll' : tagAlls.length > 20}"
        >
          <h3 class="uk-card-title">All Tags</h3>
          <span
            class="tagAll"
            @click="addTagsCusFromAlltags(tag)"
            :key="tag"
            v-for="tag in tagAlls"
          >
            <el-tag size="medium">{{ tag }}</el-tag>
          </span>
        </div>
      </div>
      <div class="bottom clearfix footer-box-tag">
        <el-button type="info" size="medium" round @click="cancelTagofCustomer">Cancel</el-button>
        <el-button
          type="success"
          size="medium"
          round
          :disabled="dynamicTags.length == 0 && (!inputValue && inputVisible) ? true : false"
          @click="saveTagOfCustomer"
        >Save</el-button>
        <el-button type="info" size="medium" round @click="gotochat(customerContact)">Chat</el-button>
      </div>
    </div>
  </el-card>
</template>
<script>
import { Card, Button, Input, Tag } from 'element-ui';
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      custNameProfile: null,
      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      isShowSuccess: false,
      isShowError: false,
      isShowMsg: null,
    };
  },
  components: {
    [Card.name]: Card,
    [Button.name]: Button,
    [Input.name]: Input,
    [Tag.name]: Tag,
  },
  computed: {
    ...mapGetters('contact', ['customerContact', 'isShowEditText']),
    ...mapGetters('chat', ['activeChatCustomer']),
    ...mapGetters('profile', ['tagAlls']),
  },
  methods: {
    enterContact(e) {
      this.custNameProfile = e;
      console.log('eeeee : ', e)
    },
    gotochat(e){
      console.log('gotochat : ', e);
      // this.$router.push('/chat');
      this.$router.push({ path: '/chat', query: { custid: e.custId } })
      //this.$store.dispatch('contact/setActiveContactCustumer', this.customerContact);
    },
    fnSaveContact() {
      var name;
      if (
        this.customerContact.custNameNew == '' ||
        this.customerContact.custNameNew == null
      ) {
        name = this.customerContact.custName;
      } else {
        name = this.customerContact.custNameNew;
      }
      let params = {
        custId: this.customerContact.custId,
        custName: this.custNameProfile == null ? name : this.custNameProfile,
      };
      console.log('custName params :', params);
      this.$store.dispatch('contact/saveContactCustumer', params.custName);
      this.$store.dispatch('chat/saveContactCustumer', params);
      if (this.activeChatCustomer != null) {
        this.$store.dispatch(
          'chat/setActiveChatCustumer',
          this.customerContact,
        );
      }
      this.$store.dispatch('contact/setActiveContactCustumer', null);
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;

      if (inputValue == null || inputValue == '' || inputValue == undefined)
        return false;
      else {
        let input = inputValue.replace(/\s/g, '');
        var sameTagCus = _.filter(this.dynamicTags, function(v) {
          let value = v.replace(/\s/g, '');
          return v == inputValue || value == input;
        });
        if (sameTagCus && sameTagCus.length > 0) return false;
        if (!input) return false;
        this.dynamicTags.push(inputValue);
        this.inputVisible = false;
        this.inputValue = '';
      }
    },
    saveTagOfCustomer() {
      let inputValue = this.inputValue;
      if (inputValue) {
        let input = inputValue.replace(/\s/g, '');
        var sameTag = _.filter(this.dynamicTags, function(v) {
          let value = v.replace(/\s/g, '');
          return v == inputValue || value == input;
        });
        if (sameTag && sameTag.length > 0) {
          this.isShowMsg = 'คุณใส่แท็กซ้ำ';
          this.isShowError = true;
          setTimeout(() => {
            this.isShowError = false;
            this.isShowMsg = null;
          }, 2000);
          return false;
        } else {
          this.handleInputConfirm();
        }
      } else {
        if (
          this.inputVisible == true &&
          !this.inputValue &&
          (inputValue == null || inputValue == '' || inputValue == undefined)
        ) {
          this.isShowMsg = 'กรุณาสร้างแท็กก่อนบันทึก';
          this.isShowError = true;
          setTimeout(() => {
            this.isShowError = false;
            this.isShowMsg = null;
          }, 2000);
          return false;
        } else {
          this.isShowSuccess = this.isShowSuccess == true ? false : true;
          const obj = {
            customerid: this.customerContact.custId,
            tags: this.dynamicTags,
          };
          this.$store.dispatch('profile/saveTagsCustomer', obj).then(v => {
            if (v.data == 'OK') {
              this.inputVisible = false;
              this.isShowSuccess = true;
              setTimeout(() => {
                this.isShowSuccess = false;
              }, 2000);
            } else {
              this.isShowError = true;
              setTimeout(() => {
                this.isShowError = false;
              }, 2000);
            }
          });
        }
      }
    },
    cancelTagofCustomer() {
      this.inputValue = '';
      this.$store.dispatch('contact/setActiveContactCustumer', null);
    },
    addTagsCusFromAlltags(data) {
      var sameAddTagAll = _.filter(this.dynamicTags, function(v) {
        return v == data;
      });
      if (sameAddTagAll && sameAddTagAll.length > 0) return false;
      this.dynamicTags.push(data);
    },
  },
  created() {
    this.$store.dispatch('profile/loadAllTags');
    this.$store
      .dispatch('profile/getTagOfCustomer', this.customerContact.custId)
      .then(v => {
        this.dynamicTags = v.data.customerTags;
      });
  },
};
</script>
<style scoped>
.box-card {
  width: 480px;
  height: 1120px;
  max-height: 1120px;
  position: fixed;
  top: 0;
}
.avatar {
  border-radius: 50%;
  border: 7px solid #00978b;
  overflow: hidden;
  width: 200px;
  height: 200px;
  margin: 0 auto;
}
.avatar img {
  height: 100%;
}
.box-card strong {
  font-size: 2.5rem;
  padding-right: 12px;
  z-index: 1;
}
.bottom {
  margin-top: 13px;
  line-height: 12px;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}
.ui-profile {
  text-align: center;
}
.clearfix:after {
  clear: both;
}
.el-button--primary {
  background-color: #00978b;
  border-color: #00978b;
  font-size: 22px;
}
.el-button--primary:hover {
  background-color: #00978bcc;
  border-color: #00978bcc;
}
.el-button--medium {
  font-size: 20px;
}
.el-button--success {
  background-color: #00978b;
  border-color: #00978b;
}
.el-button--success:hover {
  background-color: #00978bcc;
  border-color: #00978bcc;
}
.el-input {
  line-height: 7;
  zoom: 140%;
}
.close-ui-profile {
  text-align: right;
  display: block;
  font-size: 26px;
  cursor: pointer;
  color: #00978b;
}
.text-nameline {
  font-size: 20px;
  color: #b3a8a8;
  margin-top: 30px;
  margin-bottom: 15px;
}
.el-tag {
  font-size: 16px;
}
.el-tag + .el-tag {
  margin-left: 10px;
  margin-top: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 10px;
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 10px;
}
.input-new-tag {
  width: 285px;
  margin-left: 10px;
  vertical-align: bottom;
  display: block;
}
.tagAll {
  margin: 0px 10px 10px 0px !important;
  display: inline-block;
}
.box-tag {
  cursor: pointer;
}
.box-tag.scroll {
  display: inline-block;
  max-height: 350px;
  overflow-y: scroll;
}
.box-add-tag {
  max-height: 600px;
  overflow-y: overlay;
  display: block;
}
.footer-box-tag {
  /* position: fixed; */
  display: block;
  /* bottom: 0;
  height: 80px;
  background: #fff;
  width: 32%;
  padding-top: 20px; */
}
</style>



// WEBPACK FOOTER //
// src/components/ProfileInfo.vue